var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6562 10.75C21.6562 16.6367 16.8438 21.4062 11 21.4062C5.11328 21.4062 0.34375 16.6367 0.34375 10.75C0.34375 4.90625 5.11328 0.09375 11 0.09375C16.8438 0.09375 21.6562 4.90625 21.6562 10.75ZM9.75391 16.4219L17.6602 8.51562C17.918 8.25781 17.918 7.78516 17.6602 7.52734L16.6719 6.58203C16.4141 6.28125 15.9844 6.28125 15.7266 6.58203L9.28125 13.0273L6.23047 10.0195C5.97266 9.71875 5.54297 9.71875 5.28516 10.0195L4.29688 10.9648C4.03906 11.2227 4.03906 11.6953 4.29688 11.9531L8.76562 16.4219C9.02344 16.6797 9.49609 16.6797 9.75391 16.4219Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle-check.795e7a7c0ff4359c39952233eded0fc1.svg";
export { ForwardRef as ReactComponent };